(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("svg-polygon-center", [], factory);
	else if(typeof exports === 'object')
		exports["svg-polygon-center"] = factory();
	else
		root["svg-polygon-center"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition